<div class="permission-popup-overlay" *ngIf="show">
  <div class="permission-popup">
    <div class="header">
      <div class="header-content">
        <div class="icon-wrapper">
            <i class="pi pi-lock" style="font-size: 1.5rem;"></i>
        </div>
        <div class="title-section">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this resource</p>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="missing-permission-box">
        <span class="missing-label">MISSING PERMISSION</span>
        <p class="permission-description">You do not have permission to view or do this action.</p>
        <div class="code-box">{{ permission }}</div>
      </div>

      <div class="how-to-fix">
        <h3>How to Fix This:</h3>

        <div class="step">
          <div class="step-number">1</div>
          <div class="step-text"><strong>Contact your administrator</strong> to request the necessary permission for your role.</div>
        </div>

        <div class="step">
          <div class="step-number">2</div>
          <div class="step-text">Navigate to <strong>Settings &rarr; Staff Members</strong> and locate your user account.</div>
        </div>

        <div class="step">
          <div class="step-number">3</div>
          <div class="step-text">Ask an administrator to <strong>edit your role permissions</strong> and enable the required access.</div>
        </div>

        <div class="step">
          <div class="step-number">4</div>
          <div class="step-text"><strong>Logout & Login again</strong> after permissions are updated to apply changes.</div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="custom-btn-close" (click)="close()">Close</button>
      <button class="btn-contact" (click)="contactAdmin()">Contact Administrator</button>
    </div>
  </div>
</div>
